import { all } from 'redux-saga/effects';
import authSaga from './authSaga'
import dashboardSaga from './dashboardSaga'
import patientsSaga from './patientsSaga'
import bookingSaga from './bookingSaga'
import { pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function *rootSaga() {
    yield all([
        ...authSaga,
        ...dashboardSaga,
        ...patientsSaga,
        ...bookingSaga
    ])
  }

export default rootSaga